// File: DashboardService.js

//==================================================
//
//
//
// Lramirez 05-April  2017
//
//==================================================

import {Model}  from 'backbone';
import listService  from 'ListService.js';
import DeleteModal  from 'dashboard/forms/modal/FormDeleteModal.js';
import ReportDeleteModal from 'dashboard/reports/modal/ReportDeleteModal.js';
import DeleteInstanceModal  from 'dashboard/forms/modal/ConfirmDeleteInstanceModal.js';
import formFolderService from "FormFolderService.js"; 
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js"; 
import ConfirmReportDeleteModal from 'dashboard/reports/modal/ConfirmReportDeleteModal.js';
import reportFolderService from "ReportFolderService.js";
import ConnectionService from  '../views/dashboard/connections/ConnectionService';
import ActionService from  '../views/dashboard/connections/action-type/ActionService';
import RestService from "RestService.js";
import NotificationService from "NotificationService.js";
import UndoService from "UndoService.js";
import eventBus  from 'EventBus.js';
import util from 'util/Util';
import constants from "Constants"; 
import textConstants from "TextConstants";

class DashboardService {

    deleteForm() {    
        let params = listService.dashboardFormsItems.getPropValue('formItemSelected');

        let groupId = params.groupId && params.groupId.includes(params.formId) ?
                      "" :
                      params.groupId;


     
        if (params.groupType === constants.FORMS_PRIVATE_GROUP_TYPE || params.groupType === constants.FORMS_SHARED_GROUP_TYPE) { 

            let deleteModal = new DeleteModal({
                model: new Model({
                    formName: params.formName, formId: params.formId, formLink: params.formLink,
                    versionList: params.versionList, totalOpenInstances: params.totalOpenInstances,
                    groupId: groupId, groupType:params.groupType
                }), width: 470, height: 270
            });
            
            deleteModal.render().then((result)=> {
                listService.dashboardFormsItems.setDefaultValue();                 
            }).catch(err => console.log(err));
        }                
    }    

    deleteFormFolder() {
        let folderItemSelected = listService.dashboardFormsItems.getPropValue('formFolderSelected');
        
        return RestService.getFormsByGroupType(folderItemSelected.groupType, folderItemSelected.formId).then((data) => {
            const hasChildren = !!data.RESULT.RESPONSE.Group;
            const titleDelete =  `Are you sure you want to delete this folder ${folderItemSelected.formName}?`;
            const titleWarning = 'This folder contains apps and cannot be deleted unless it is empty.';
            
            let simpleModal = util.createDialogDeleteConfirmation("Delete Folder", hasChildren ? titleWarning : titleDelete, !hasChildren);
             
            simpleModal.render().then((result) => {
                if (result === 'Ok' && !hasChildren) {
                    let deleteFormFolderPromise = formFolderService.deleteFormFolder(folderItemSelected.formName,
                        folderItemSelected.formId,
                        folderItemSelected.groupTypeId,
                        folderItemSelected.groupId);
            
                    deleteFormFolderPromise.then(result => {
                        listService.dashboardFormsItems.setDefaultValue();
                        eventBus.trigger('deletingForm', folderItemSelected.formId, true);
                    });                
                }
            });    
        }).catch((err)=> {
                console.log('Error Showing Action List Confirmation Message', err);
                NotificationService.error('Error Showing Action List Confirmation Message' + err.MESSAGE);
        });             
    }

    deleteReport() {
        let params = listService.reportItemSelected;
        let groupId = params.groupId && params.groupId.includes(params.formId) ?
            "" :
            params.groupId;

        //Only from Edit Reports
        if (params && params.groupType !== "viewReports" && params.nodeType !== "group") {
            let reportDeleteModal = new ReportDeleteModal({
                model: new Model({
                    reportName: params.reportName, reportId: params.reportId, reportLink: params.reportLink,
                    versionList: params.versionList, groupType: params.groupType, groupId:groupId
                })
            });
            reportDeleteModal.render().then((result)=> {
                console.log(result);
            }).catch(err => console.log(err));
        }        
    }

    deleteReportFromTree() {
        let params = listService.reportItemSelected; 
        //Only from Edit Reports
        if (params && params.groupType !== "viewReports" && params.nodeType !== "group") {

            let model = new Model({reportName: params.reportName,
                reportId: params.reportId, reportLink: params.reportLink,
                versionList: params.versionList, mode: 'deleteReport',
                groupId: params.groupType, groupType: params.groupType
            });

            var confirmReportDeleteModal = new ConfirmReportDeleteModal({ model });
            confirmReportDeleteModal.render().then((result)=>{
                listService.reportItemSelected = undefined;
                return(result);
            }, rejectReason => { 
                //this is to receive the rejection from the main window, 
                //no action required.
            }).catch((error) => {
                var msg = error || 'Unknown Error';
                NotificationService.error(msg);
                return(error);
            });
        }        
    }   

    deleteConnection() {
        let params = listService.connectionItemSelected;
        let simpleModal = util.createDialogDeleteConfirmation("Delete Connection", `Are you sure you want to delete the connection ${params.name}?`);
      
        simpleModal.render().then((result)=>{
            if (result === 'Ok') {
                ConnectionService.makeDeleteConnection(params.connectionId, params.connectionType);
                listService.connectionItemSelected = undefined;
            }
        }).catch((err)=> {
            console.log('Error Showing Delete List Confirmation Message', err);
            NotificationService.error('Error Showing Delete List Confirmation Message' + err.MESSAGE);
        });
    }    

    deleteAction() {
        let actionItemSelected = listService.actionItemSelected;
        let simpleModal = util.createDialogDeleteConfirmation("Delete Connection", `Are you sure you want to delete the action ${actionItemSelected.name}?`);
         
        simpleModal.render().then((result)=>{
            if (result === 'Ok') {
                ActionService.makeDeleteAction(actionItemSelected.actionId, actionItemSelected.connectionId, actionItemSelected.type);
                listService.actionItemSelected = undefined;
            }
        }).catch((err)=> {
            console.log('Error Showing Action List Confirmation Message', err);
            NotificationService.error('Error Showing Action List Confirmation Message' + err.MESSAGE);
        });
    }

    deleteUserModal() {
        let simpleModal=new SimpleConfirmModalView({
            model:new Model({subtitle:"Delete User",
                confirmationText:`Are you sure you want to delete the selected user?`,
                height: 'auto',
                width: 400})
        });
        simpleModal.render().then((result)=>{
            if (result === 'Ok') {
                let currentUserId = listService.userItemSelected.userId;
                this.deleteUser(currentUserId).then((result) => {
                    UndoService.add({
                        redo: () => {
                            this.deleteUser(currentUserId);
                        },
                        undo: () => {
                            this.unDeleteUser(currentUserId);
                        }
                    }, textConstants.UNDO_DELETE_USER)
                });
            }
        }).catch((err)=> {
            console.log('Error Showing Delete List Confirmation Message', err);
        });
    }

    deleteUser(userId){
        return RestService.deleteUser(userId).then(function(){
            return eventBus.trigger( constants.EV_DELETE_USER,userId);
        }); 
    }

    unDeleteUser(userId){

        return RestService.unDeleteUser(userId).then( data => {
            let fullName=`${data.FirstName || ""} ${data.LastName || ""}`;
            if(listService.activeDashboardTab === 'settings') {
                eventBus.trigger(constants.EV_OPEN_UNDELETED_USER_DETAILS, userId);
            }
            else{
                NotificationService.success(`User ${fullName} was restored`);
            }
            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    deleteUserGroup() {       
       let userGroupItem = listService.dashboardSettingsItems.getPropValue('userGroup');
       let simpleModal = util.createDialogDeleteConfirmation("Delete User Group", `Are you sure you want to delete this user-group ${userGroupItem.name}?`);
         
       simpleModal.render().then((result) => {
            if (result === 'Ok') {
                this.deleteUserGroupPromise(userGroupItem).then((result) =>{
                    UndoService.add({
                        undo:() => {
                            this.unDeleteUserGroup(userGroupItem);
                        },
                        redo:() => {
                            this.deleteUserGroupPromise(userGroupItem);
                        }
                    },textConstants.UNDO_DELETE_USER_GROUP)
                });
            }
       }).catch((err)=> {
            console.log('Error Showing Delete Group Confirmation Message', err);
            NotificationService.error('Error Showing Delete Group Confirmation Message' + err.MESSAGE);
       });
    }


    unDeleteUserGroup(userGroupItem){

        return RestService.undeleteUserGroup(userGroupItem.id).then( data => {
            if(listService.activeDashboardTab === 'settings') {
                eventBus.trigger(constants.EV_OPEN_UNDELETED_USER_GROUP_DETAILS, userGroupItem);
            }

             NotificationService.success(`User Group ${userGroupItem.name} was restored`);

            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    deleteUserGroupPromise(userGroupItem) {
        return RestService.deleteUserGroup(userGroupItem.id).then((data)=> {
            eventBus.trigger(constants.USER_GROUP_DELETED);
            listService.dashboardSettingsItems.setDefaultValue();
        }).catch((error)=> {
            console.log('Error deleting group', error);
            if (error.CODE === '75') {
                NotificationService.error('An error has ocurred. The maximum number of users with offline app filling enabled has been reached.')
            }
        });
    }

    deleteUserPosition() {       
        let userPositionItem = listService.dashboardSettingsItems.getPropValue('userPosition');
        let simpleModal = util.createDialogDeleteConfirmation("Delete User Position", `Are you sure you want to delete this position ${userPositionItem.name}?`);
          
        simpleModal.render().then((result) => {
             if (result === 'Ok') {
                 this.deleteUserPositionPromise(userPositionItem).then((result) =>{
                     UndoService.add({
                         undo:() => {
                             this.unDeleteUserPosition(userPositionItem);
                         },
                         redo:() => {
                             this.deleteUserPositionPromise(userPositionItem);
                         }
                     },textConstants.UNDO_DELETE_POSITION)
                 });
             }
        }).catch((err)=> {
             console.log('Error Showing Position Delete Confirmation Message', err);
             NotificationService.error('Error Showing Position Delete Confirmation Message' + err.MESSAGE);
        });
     }

    unDeleteUserPosition(userPositionItem){

        return RestService.undeletePosition(userPositionItem.id).then( data => {
            if(listService.activeDashboardTab === 'settings') {
                eventBus.trigger(constants.EV_OPEN_UNDELETED_USER_POSITION_DETAILS, userPositionItem);
            }

            NotificationService.success(`User Position ${userPositionItem.name} was restored`);

            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

     deleteUserPositionPromise(userPositionItem) {
        return RestService.deleteUserPosition(userPositionItem.id).then((data)=> {
          eventBus.trigger(constants.USER_POSITION_DELETED);
          listService.dashboardSettingsItems.setDefaultValue();
          console.log('result', data)
        }).catch((error)=> {
          console.log('Error deleting position', error);
        });
    }

    deleteUserList() {
        let userListItem = listService.dashboardSettingsItems.getPropValue('userList');
        let simpleModal = util.createDialogDeleteConfirmation("Delete User List", `Are you sure you want to delete this list ${userListItem.name}?`);
          
        simpleModal.render().then((result) => {
             if (result === 'Ok') {
                 this.deleteUserListPromise(userListItem).then((result) =>{
                     UndoService.add({
                         undo:() => {
                             this.unDeleteUserList(userListItem);
                         },
                         redo:() => {
                             this.deleteUserListPromise(userListItem);
                         }
                     },textConstants.UNDO_DELETE_CUSTOM_LIST)
                 });
             }
        }).catch((err)=> {
             console.log('Error Showing List Delete Confirmation Message', err);
             NotificationService.error('Error Showing List Delete Confirmation Message' + err.MESSAGE);
        });
     }

     deleteUserListPromise(userListItem) {
        return RestService.deleteCustomList(userListItem.id).then((response)=>{ 
            eventBus.trigger(constants.EV_DELETE_CUSTOM_LIST);
            listService.dashboardSettingsItems.setDefaultValue();
        }).catch((err)=> {
            console.log('Error Deleting List', err);
        });
    }

    unDeleteUserList(userListItem){

        return RestService.undeleteCustomList(userListItem.id).then( data => {
            if(listService.activeDashboardTab === 'settings') {
                eventBus.trigger(constants.EV_OPEN_UNDELETED_LIST_DETAILS, userListItem.id);
            }

            NotificationService.success(`User List ${userListItem.name} was restored`);
            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    deleteUserEmailServer() {       
        let userEmailItem = listService.dashboardSettingsItems.getPropValue('userEmail');
        let simpleModal = util.createDialogDeleteConfirmation("Delete User List", `Are you sure you want to delete this email server ${userEmailItem.name}?`);
          
        simpleModal.render().then((result) => {
             if (result === 'Ok') {
                 this.deleteUserEmailPromise(userEmailItem).then((result) => {
                     UndoService.add({
                         undo: () => {
                             this.unDeleteUserEmailServer(userEmailItem);
                         },
                         redo: () => {
                             this.deleteUserEmailPromise(userEmailItem);
                         }
                     },textConstants.UNDO_DELETE_EMAIL_SERVER)
                 });
             }
        }).catch((err)=> {
             console.log('Error Showing List Delete Confirmation Message', err);
             NotificationService.error('Error Showing List Delete Confirmation Message' + err.MESSAGE);
        });
     }

     deleteUserEmailPromise(userEmailItem) {
        return RestService.deleteEmailServer(userEmailItem.id).then((response)=>{
            eventBus.trigger(constants.EV_DELETE_EMAIL_SERVER);
            listService.dashboardSettingsItems.setDefaultValue();
        }).catch((err)=> {
            console.log('Error Deleting Email Server', err);
            NotificationService.error('Error Deleting Email Server' + err.MESSAGE);
        });
    }

    unDeleteUserEmailServer(userEmailItem){

        return RestService.undeleteEmailServer(userEmailItem.id).then( data => {
            if(listService.activeDashboardTab === 'settings') {
                eventBus.trigger(constants.EV_OPEN_UNDELETED_EMAIL_SERVER_DETAILS, userEmailItem.id);
            }

            NotificationService.success(`User Email Server ${userEmailItem.name} was restored`);

            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

 
    deleteInstance(instanceId, fromLandingPage = false, formInstanceList) {
        let instance = !instanceId ? listService.dashboardFormsItems.getPropValue('instanceItemSelected') : instanceId; 
        if (instance) {

            if (!Array.isArray(instance)) {
                instance = [instance.id];
            }

            let formInstancesXML = "<FormInstances>";

            _.each(instance, (id) => {
               formInstancesXML += `<FormInstance id="${id}"/>`
            });     
            
            formInstancesXML += "</FormInstances>";

            formInstancesXML = formInstancesXML.replace(/</g, '&lt;').replace(/>/g, '&gt;')

            let deleteModal = new DeleteInstanceModal({
                model: new Model({
                    formInstances: instance,
                    formInstancesXML: formInstancesXML,
                    instanceCount: instance.length,
                    formInstanceList: formInstanceList
                })
            });

            deleteModal.render().then((result) => {   
                
                listService.dashboardSettingsItems.setDefaultValue();
                if (!fromLandingPage) {
                    //PF-6449 add timeout to allow the delete service to complete before changing views
                    setTimeout(function () {
                        eventBus.trigger('displayDefaultEditFormsDetailView');
                    },500);                 
                }
     
            }).catch(err => console.log(err));
        } 
    }
   

    deleteReportFolder() {
        let folderItemSelected = listService.reportItemSelected;
        return RestService.getReportsByGroupType(folderItemSelected.groupType, folderItemSelected.reportId).then((data) => {
            
            const hasChildren = !!data.RESULT.RESPONSE.Group;
            const titleDelete =  `Are you sure you want to delete this folder ${folderItemSelected.reportName}?`;
            const titleWarning = 'This folder contains reports and cannot be deleted unless it is empty.';
            
            let simpleModal = util.createDialogDeleteConfirmation("Delete Folder", hasChildren ? titleWarning : titleDelete, !hasChildren);
     
            simpleModal.render().then((result) => {
                if (result === 'Ok' && !hasChildren) {
                    let deleteReportPromise = reportFolderService.deleteReportFolder(folderItemSelected.reportName,folderItemSelected.reportId,folderItemSelected.groupType);

                    deleteReportPromise.then(result => {
                        listService.reportItemSelected = undefined;
                        eventBus.trigger('deletingReport', folderItemSelected.reportId, true);
                    });                
                }
            }).catch((err)=> {
                console.log('Error Showing Action List Confirmation Message', err);
                NotificationService.error('Error Showing Action List Confirmation Message' + err.MESSAGE);
            });      
        }); 
    }      
}


//==========================================================================================
// Export the instance, not the class. A singleton instance.
//==========================================================================================
const dashboardService = new DashboardService();
export default dashboardService;
